import { render, staticRenderFns } from "./Multiedit.vue?vue&type=template&id=0ec3d6b6"
import script from "./Multiedit.vue?vue&type=script&lang=ts"
export * from "./Multiedit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports